import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import GridLayout from '../../../components/modules/GridLayout';
import CartCheckoutHeader from '../CartCheckoutHeader';
// rename??
import InfoComponentsByDevice from './InfoComponentsByDevice';
import ErrorNotificationBanner from './ErrorNotificationBanner';
import { formatValueProps, ValueProps, VpnNotificationBanner } from '@chegg/commerce-utils';
import { NotificationBanner, NotificationTypes } from '@chegg-ui/notification-banner';
import { DEFAULT_LAYOUT_TESTID, FULL_PM_VIEW_CLASS, PAYMENT_LEFT_CLASS, PAYMENT_RIGHT_CLASS, SALE_BANNER_ID } from '../constants';
import { PaymentWrapper } from '../styled';
import onError from '../../../utils/onError';
import GridFooter from './GridFooter';
import DropInPaymentsLayout from './DropInPaymentsLayout';
import { colors, createTheme, ThemeProvider, themes } from '@chegg-ui/theme';
import { showSaleBanner } from '../../../utils/showSaleBanner';
import { Link } from '@chegg-ui/link';
import { getUniqueIDLookUp } from '../../../utils/TransformUtils';
import { PaddingContainer } from '../../../components/common/styled';
import { getMonthlyBasePrice, getSavingsPercentage } from '../helpers';
var DefaultCheckoutLayout = function DefaultCheckoutLayout(_ref) {
  var _content$cta;
  var authorization = _ref.authorization,
    calculatedPrice = _ref.calculatedPrice,
    content = _ref.content,
    ctaContent = _ref.ctaContent,
    displayServerErrors = _ref.displayServerErrors,
    headingLevel = _ref.headingLevel,
    isMobile = _ref.isMobile,
    isReviewStep = _ref.isReviewStep,
    isVpnDetected = _ref.isVpnDetected,
    reviewStepEnabled = _ref.reviewStepEnabled,
    tax = _ref.tax,
    tncProps = _ref.tncProps,
    uiData = _ref.uiData,
    environment = _ref.environment,
    optimizelyClient = _ref.optimizelyClient,
    referrer = _ref.referrer,
    taxInfo = _ref.taxInfo,
    userUuid = _ref.userUuid,
    useForter = _ref.useForter,
    withCoupon = _ref.withCoupon,
    dipCommands = _ref.dipCommands,
    action = _ref.action,
    country = _ref.country,
    externalId = _ref.externalId,
    isCTALoading = _ref.isCTALoading,
    experiment = _ref.experiment,
    hasNeedHelpButton = _ref.hasNeedHelpButton,
    products = _ref.products,
    couponCode = _ref.couponCode,
    priceWithDiscount = _ref.priceWithDiscount,
    recurlyCart = _ref.recurlyCart,
    isRecurly = _ref.isRecurly;
  tncProps.ctaLabel = ((_content$cta = content.cta) === null || _content$cta === void 0 ? void 0 : _content$cta.cta) || '';
  var errorModal = content.errorModal,
    subscriptionInfo = content.subscriptionInfo,
    coupon = content.coupon,
    orderSummary = content.orderSummary,
    paymentForm = content.paymentForm,
    paymentErrorModal = content.paymentErrorModal,
    paymentMethodsHeadingText = content.paymentMethodsHeadingText,
    valueProps = content.valueProps,
    saleBanner = content.saleBanner,
    notificationBanner = content.notificationBanner,
    badgeUpToPercentOff = content.badgeUpToPercentOff;
  var hasError = (uiData === null || uiData === void 0 ? void 0 : uiData.errorMessage) && displayServerErrors;
  var theme = createTheme({}, themes.horizon);
  var savingsPercentage = getSavingsPercentage(products[0]);
  var basePrice = getMonthlyBasePrice(products[0]);
  var isDiscounted = savingsPercentage > 0 || !!priceWithDiscount;
  var footerContent = /*#__PURE__*/React.createElement(GridFooter, {
    authorization: authorization,
    isMobile: isMobile,
    newUserNoMop: uiData === null || uiData === void 0 ? void 0 : uiData.newUserNoMop,
    isReviewStep: isReviewStep,
    reviewStepEnabled: reviewStepEnabled,
    ctaContent: ctaContent,
    tax: tax,
    tncProps: tncProps,
    selectedPrice: calculatedPrice,
    termsAndConditions: tncProps.termsAndConditions,
    basePrice: basePrice,
    isDiscounted: isDiscounted
  });
  var showStickyCTAFooter = isReviewStep || (uiData === null || uiData === void 0 ? void 0 : uiData.newUserNoMop) || isMobile && !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM);
  var eligibleToShowVpnBanner = isVpnDetected && !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM);
  var eligibleToShowSaleBanner = showSaleBanner(experiment) && !isVpnDetected && !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM);
  var uniqueIdLookup = getUniqueIDLookUp(paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm.paymentFields);
  var _uniqueIdLookup$getHe = uniqueIdLookup.getHeadingTexts(),
    addPaymentMethodHeading = _uniqueIdLookup$getHe.addPaymentMethodHeading,
    editPaymentMethodHeading = _uniqueIdLookup$getHe.editPaymentMethodHeading;
  return /*#__PURE__*/React.createElement(GridLayout, _extends({
    dataTest: DEFAULT_LAYOUT_TESTID
  }, showStickyCTAFooter && {
    footer: footerContent
  }, {
    showOnlyPm: uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM,
    reviewStepEnabled: reviewStepEnabled,
    hasNeedHelpButton: hasNeedHelpButton
  }), /*#__PURE__*/React.createElement(CartCheckoutHeader, {
    content: subscriptionInfo,
    headingLevel: headingLevel,
    showOnlyPM: uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM,
    cardActionMode: uiData === null || uiData === void 0 ? void 0 : uiData.cardActionMode,
    newUserNoMop: uiData === null || uiData === void 0 ? void 0 : uiData.newUserNoMop,
    allowPlanSelection: false,
    addPaymentMethodHeading: addPaymentMethodHeading,
    editPaymentMethodHeading: editPaymentMethodHeading,
    selectedPrice: tncProps.price,
    isCouponApplied: tncProps.isCouponApplied,
    priceWithDiscount: tncProps.priceWithDiscount,
    authorization: authorization,
    savingsPercentage: savingsPercentage,
    saleBannerHeaderContent: saleBanner === null || saleBanner === void 0 ? void 0 : saleBanner.bannerTitle,
    saleBannerBadgeContent: badgeUpToPercentOff,
    action: action,
    country: country
  }), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && hasError && /*#__PURE__*/React.createElement(ErrorNotificationBanner, {
    errorMessage: uiData.errorMessage
  }), /*#__PURE__*/React.createElement(PaymentWrapper, {
    onlyPM: uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM,
    isReviewStep: isReviewStep,
    newUserNoMop: uiData === null || uiData === void 0 ? void 0 : uiData.newUserNoMop,
    reviewStepEnabled: reviewStepEnabled
  }, /*#__PURE__*/React.createElement("div", {
    className: uiData !== null && uiData !== void 0 && uiData.showOnlyPM ? FULL_PM_VIEW_CLASS : PAYMENT_LEFT_CLASS
  }, (uiData === null || uiData === void 0 ? void 0 : uiData.showInitializeError) && /*#__PURE__*/React.createElement(NotificationBanner, {
    id: 'initializeErrorBanner',
    title: (errorModal === null || errorModal === void 0 ? void 0 : errorModal.header) || /* istanbul ignore next */'',
    type: NotificationTypes.Error,
    message: (errorModal === null || errorModal === void 0 ? void 0 : errorModal.body) || /* istanbul ignore next */''
  }), (uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM) && hasError && /*#__PURE__*/React.createElement(ErrorNotificationBanner, {
    errorMessage: uiData.errorMessage
  }), paymentMethodsHeadingText && /*#__PURE__*/React.createElement(DropInPaymentsLayout, {
    authorization: authorization,
    isReviewStep: isReviewStep,
    coupon: coupon,
    orderSummary: orderSummary,
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    reviewStepEnabled: reviewStepEnabled,
    environment: environment,
    optimizelyClient: optimizelyClient,
    referrer: referrer,
    taxInfo: taxInfo,
    userUuid: userUuid,
    useForter: useForter,
    withCoupon: withCoupon,
    dipCommands: dipCommands,
    action: action,
    country: country,
    externalId: externalId,
    isCTALoading: isCTALoading,
    venmoVisible: true,
    googlepayVisible: true,
    couponCode: couponCode,
    recurlyCart: recurlyCart,
    isRecurly: isRecurly
  }), isMobile && eligibleToShowSaleBanner && /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(NotificationBanner, {
    id: SALE_BANNER_ID,
    title: saleBanner === null || saleBanner === void 0 ? void 0 : saleBanner.bannerTitle,
    "data-test": SALE_BANNER_ID,
    type: NotificationTypes.Information,
    message: '',
    ctaLink: /*#__PURE__*/React.createElement(Link, {
      size: "sm",
      href: "".concat(authorization.cheggBaseUrl).concat(saleBanner === null || saleBanner === void 0 ? void 0 : saleBanner.link),
      target: "_blank",
      rel: "noreferrer noopener",
      style: {
        color: colors.dark,
        textDecoration: 'underline'
      }
    }, saleBanner === null || saleBanner === void 0 ? void 0 : saleBanner.linkText),
    fluid: true
  }))), isMobile && eligibleToShowVpnBanner && /*#__PURE__*/React.createElement(PaddingContainer, {
    bottom: 10
  }, /*#__PURE__*/React.createElement(VpnNotificationBanner, {
    bannerTitle: notificationBanner === null || notificationBanner === void 0 ? void 0 : notificationBanner.bannerTitle,
    link: notificationBanner === null || notificationBanner === void 0 ? void 0 : notificationBanner.link,
    linkText: notificationBanner === null || notificationBanner === void 0 ? void 0 : notificationBanner.linkText,
    isMobile: isMobile,
    allowPlanSelection: false
  })), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && /*#__PURE__*/React.createElement("div", {
    className: PAYMENT_RIGHT_CLASS
  }, valueProps && /*#__PURE__*/React.createElement(ValueProps, {
    content: formatValueProps(valueProps),
    onError: onError
  }))), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && /*#__PURE__*/React.createElement(InfoComponentsByDevice, {
    authorization: authorization,
    newUserNoMop: uiData === null || uiData === void 0 ? void 0 : uiData.newUserNoMop,
    content: content,
    ctaContent: ctaContent,
    allowPlanSelection: false,
    isMobile: isMobile,
    isReviewStep: isReviewStep,
    price: calculatedPrice,
    basePrice: basePrice,
    reviewStepEnabled: reviewStepEnabled,
    tax: tax,
    tncProps: tncProps,
    eligibleToShowVpnBanner: eligibleToShowVpnBanner,
    eligibleToShowSaleBanner: eligibleToShowSaleBanner,
    isDiscounted: isDiscounted
  }));
};
export default DefaultCheckoutLayout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/DefaultCheckoutLayout.js
// module id = 4354
// module chunks = 11